
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/privacy/subprocessors/modulabs-subprocessors",
      function () {
        return require("private-next-pages/terms/privacy/subprocessors/modulabs-subprocessors.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/privacy/subprocessors/modulabs-subprocessors"])
      });
    }
  